export default __webpack_public_path__ + "static/ISO_2007-2bd16cacd24e6c20ed8bf04e6797b349.svg";